import React, {Component} from 'react';
import { Col, CardHeader, Modal, ModalBody, ModalFooter, TabContent, TabPane, FormGroup, InputGroup, Label, Input, FormText, Button } from 'reactstrap';
import LaddaButton, { EXPAND_LEFT } from 'react-ladda';
import MaskedInput from 'react-text-mask';

import Config from '../../config';

import './Editor.css';

class ClientEditor extends Component {
 constructor(props) {
  super(props);

  this.setValue = this.setValue.bind(this);
  this.handleTabs = this.handleTabs.bind(this);
  this.handleSave = this.handleSave.bind(this);
  this.handleClose = this.handleClose.bind(this);
  
  this.state = {
   activeTab: '1',
   titleTab: 'Alta de cliente',
   laddaloading: false,
   errMessage: false,
   editorMode: false,
   classNames: {
    companyID: "form-control uppercase",
    companyName: "form-control",
    companyAddress: "form-control",
    companyLocality: "form-control",
    companyState: "form-control",
    companyPotalCode: "form-control",
    companyCountry: "form-control",
    contactFirstName: "form-control",
    contactSurName: "form-control",
    contactPosition: "form-control",
    contactAddress: "form-control",
    contactLocality: "form-control",
    contactState: "form-control",
    contactPotalCode: "form-control",
    contactCountry: "form-control",
    contactPhone: "form-control",
    contactMobile: "form-control",
    contactFax: "form-control",
    contactEmail: "form-control",
    paymentBankName: "form-control",
    paymentBankAccount: "form-control",
    paymentCardNumber: "form-control",
    paymentCardExpire: "form-control",
    paymentCardCode: "form-control"
   }
  }
 }

 resetAll() {
  this.setState({
   activeTab: '1',
   titleTab: 'Alta de cliente',
   laddaloading: false,
   errMessage: false,
   editorMode: false,
   client: {
    clientID: 0,
    companyID: '',
    companyName: '',
    companyAddress: '',
    companyLocality: '',
    companyState: '',
    companyPotalCode: '',
    companyCountry: '',
    contactFirstName: '',
    contactSurName: '',
    contactPosition: '',
    contactAddress: '',
    contactLocality: '',
    contactState: '',
    contactPotalCode: '',
    contactCountry: '',
    contactPhone: '',
    contactMobile: '',
    contactFax: '',
    contactEmail: '',
    paymentBankName: null,
    paymentBankAccount: null,
    paymentCardNumber: null,
    paymentCardExpire: null,
    paymentCardCode: null
   },
   classNames: {
    companyID: "form-control uppercase",
    companyName: "form-control",
    companyAddress: "form-control",
    companyLocality: "form-control",
    companyState: "form-control",
    companyPotalCode: "form-control",
    companyCountry: "form-control",
    contactFirstName: "form-control",
    contactSurName: "form-control",
    contactPosition: "form-control",
    contactAddress: "form-control",
    contactLocality: "form-control",
    contactState: "form-control",
    contactPotalCode: "form-control",
    contactCountry: "form-control",
    contactPhone: "form-control",
    contactMobile: "form-control",
    contactFax: "form-control",
    contactEmail: "form-control",
    paymentBankName: "form-control",
    paymentBankAccount: "form-control",
    paymentCardNumber: "form-control",
    paymentCardExpire: "form-control",
    paymentCardCode: "form-control"
   }
  })
 }

 setValue(e) {
  var newClient = this.state.client;
  newClient[e.target.id] = e.target.value;
  this.setState({client: newClient});
 }

 handleTabs(tab) {
  switch(tab) {
   case '1': var title = 'Datos de la empresa'; break;
   case '2': var title = 'Datos de contacto'; break;
   case '3': var title = 'Metodos de pago'; break;
  }
  this.setState({titleTab: title, activeTab: tab});
 }

 handleSave() {
  var errorFileds = this.state.classNames;
  Object.keys(errorFileds).map(function(key, index) { errorFileds[key] = errorFileds[key].replace(' border border-danger', ''); });
  this.setState({laddaloading: true, classNames: errorFileds});
  this.props.reqAPI(Config.apiURI+'/api/clients/editor', 'POST', this.state.client).then((result) => {
   if(result.success) {
    this.props.onComplete(result.client);
    this.resetAll();
   } else {
    var errorFileds = this.state.classNames;
    result.failed.map((key) => { errorFileds[key] = errorFileds[key] + " border border-danger"; });
    this.setState({laddaloading: false, errMessage: result.message, classNames: errorFileds});
   }
  }).catch((error) => {
   console.log(error);
   this.setState({laddaloading: false});
  })
 }

 handleClose() {
  this.props.handleClose();
  this.resetAll();
 }

 componentWillMount() {
  this.resetAll();
 }

 componentWillUpdate() {
  if(this.props.client != null && !this.state.editorMode) {
   this.setState({
    editorMode: true,
    client: {
     clientID: parseInt(this.props.client.ID),
     companyID: this.props.client.NID ? this.props.client.NID : '',
     companyName: this.props.client.name ? this.props.client.name : '',
     companyAddress: this.props.client.address ? this.props.client.address : '',
     companyLocality: this.props.client.locality ? this.props.client.locality : '',
     companyState: this.props.client.state ? this.props.client.state : '',
     companyCountry: 'España',
     companyPotalCode: this.props.client.postcode ? this.props.client.postcode : '',
     contactFirstName: this.props.client.contactFirstname ? this.props.client.contactFirstname : '',
     contactSurName: this.props.client.contactSurname ? this.props.client.contactSurname : '',
     contactPosition: this.props.client.contactDepartment ? this.props.client.contactDepartment : '',
     contactAddress: this.props.client.contactAddress ? this.props.client.contactAddress : '',
     contactLocality: this.props.client.contactLocality ? this.props.client.contactLocality : '',
     contactState: this.props.client.contactState ? this.props.client.contactState : '',
     contactPotalCode: this.props.client.contactPostcode ? this.props.client.contactPostcode : '',
     contactCountry: this.props.client.contactCountry ? this.props.client.contactCountry : '',
     contactPhone: this.props.client.contactPhone ? this.props.client.contactPhone : '',
     contactMobile: this.props.client.contactMobile ? this.props.client.contactMobile : '',
     contactFax: this.props.client.contactFax ? this.props.client.contactFax : '',
     contactEmail: this.props.client.contactEmail ? this.props.client.contactEmail : ''
    }
   });
  }
 }

 render() {
  return (
   <Modal className="modal-lg ModalClient" isOpen={this.props.open}>
    <CardHeader>
     <i className="fa fa-address-book-o"></i><strong>{this.state.titleTab}</strong>
     <div className="card-actions bg-light">
      <Button disabled={this.state.activeTab !== '1'?false:true} onClick={() => this.handleTabs('1')}><i className="fa fa-user-circle"></i></Button>
      <Button disabled={this.state.activeTab !== '2'?false:true} onClick={() => this.handleTabs('2')}><i className="fa fa-address-card-o"></i></Button>
      <Button disabled={this.state.activeTab !== '3'?false:true} onClick={() => this.handleTabs('3')}><i className="fa fa-credit-card-alt"></i></Button>
     </div>
    </CardHeader>

    <ModalBody>
     <TabContent activeTab={this.state.activeTab}>
      <TabPane tabId="1">
       <FormGroup row>
        <Col xs="9">
         <FormGroup className="form-group-clean">
          <Label htmlFor="company">Nombre</Label>
          <Input type="text" id="companyName" value={this.state.client.companyName} onChange={(e) => {this.setValue(e)}} placeholder="Introduce el nombre completo del cliente o la empresa" className={this.state.classNames.companyName} />
         </FormGroup>
        </Col>
        <Col xs="3">
         <FormGroup className="form-group-clean">
          <Label htmlFor="vat">Nº Identificación fiscal</Label>
          <MaskedInput disabled={this.state.editorMode} id="companyID" value={this.state.client.companyID} onChange={(e) => {this.setValue(e)}} mask={[/\w/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\w/]} className={this.state.classNames.companyID} />
         </FormGroup>
        </Col>
       </FormGroup>

       <FormGroup>
        <Label htmlFor="street">Dirección</Label>
        <Input type="text" id="companyAddress" value={this.state.client.companyAddress} onChange={(e) => {this.setValue(e)}} placeholder="Introduce la dirección de facturación" className={this.state.classNames.companyAddress} />
       </FormGroup>

       <FormGroup row>
        <Col xs="8">
         <FormGroup className="form-group-clean">
          <Label htmlFor="city">Localidad / Ciudad</Label>
          <Input type="text" id="companyLocality" value={this.state.client.companyLocality} onChange={(e) => {this.setValue(e)}} placeholder="Introduce la ciudad o población" className={this.state.classNames.companyLocality} />
         </FormGroup>
        </Col>
        <Col xs="4">
         <FormGroup className="form-group-clean">
          <Label htmlFor="postal-code">Código Postal</Label>
          <MaskedInput id="companyPotalCode" value={this.state.client.companyPotalCode} onChange={(e) => {this.setValue(e)}} mask={[/\d/, /\d/, /\d/, /\d/, /\d/]} className={this.state.classNames.companyPotalCode} />
         </FormGroup>
        </Col>
       </FormGroup>

       <FormGroup row>
        <Col xs="6">
         <FormGroup className="form-group-clean">
          <Label htmlFor="city">Provincia</Label>
          <Input type="text" id="companyState" value={this.state.client.companyState} onChange={(e) => {this.setValue(e)}} placeholder="Introduce la provincia" className={this.state.classNames.companyState} />
         </FormGroup>
        </Col>
        <Col xs="6">
         <FormGroup className="form-group-clean">
          <Label htmlFor="postal-code">Pais</Label>
          <Input type="text" id="companyCountry" value={this.state.client.companyCountry} onChange={(e) => {this.setValue(e)}} placeholder="Introduce el pais" className={this.state.classNames.companyCountry} />
         </FormGroup>
        </Col>
       </FormGroup>
      </TabPane>


      <TabPane tabId="2">
       <FormGroup row>
        <Col xs="4">
         <FormGroup className="form-group-clean">
          <Label htmlFor="company">Nombre</Label>
          <Input type="text" id="contactFirstName" value={this.state.client.contactFirstName} onChange={(e) => {this.setValue(e)}} placeholder="Introduce el nombre" className={this.state.classNames.contactFirstName} />
         </FormGroup>
        </Col>
        <Col xs="5">
         <FormGroup className="form-group-clean">
          <Label htmlFor="vat">Apellidos</Label>
          <Input type="text" id="contactSurName" value={this.state.client.contactSurName} onChange={(e) => {this.setValue(e)}} placeholder="Introduce los apellidos" className={this.state.classNames.contactSurName} />
         </FormGroup>
        </Col>

        <Col xs="3">
         <FormGroup className="form-group-clean">
          <Label htmlFor="vat">Cargo en la empresa</Label>
          <Input type="text" id="contactPosition" value={this.state.client.contactPosition} onChange={(e) => {this.setValue(e)}} placeholder="Administrador" className={this.state.classNames.contactPosition} />
         </FormGroup>
        </Col>
       </FormGroup>

       <FormGroup row>
        <Col xs="7">
         <FormGroup className="form-group-clean">
          <Label htmlFor="city">Dirección</Label>
          <Input type="text" id="contactAddress" value={this.state.client.contactAddress} onChange={(e) => {this.setValue(e)}} placeholder="Introduce la dirección de contacto" className={this.state.classNames.contactAddress} />
         </FormGroup>
        </Col>
        <Col xs="5">
         <FormGroup className="form-group-clean">
          <Label htmlFor="city">Localidad / Ciudad</Label>
          <Input type="text" id="contactLocality" value={this.state.client.contactLocality} onChange={(e) => {this.setValue(e)}} placeholder="Introduce la ciudad o población" className={this.state.classNames.contactLocality} />
         </FormGroup>
        </Col>
       </FormGroup>

       <FormGroup row>
        <Col xs="4">
         <FormGroup className="form-group-clean">
          <Label htmlFor="city">Provincia</Label>
          <Input type="text" id="contactState" value={this.state.client.contactState} onChange={(e) => {this.setValue(e)}} placeholder="Introduce la provincia" className={this.state.classNames.contactState} />
         </FormGroup>
        </Col>
        <Col xs="2">
         <FormGroup className="form-group-clean">
          <Label htmlFor="postal-code">Código Postal</Label>
          <MaskedInput id="contactPotalCode" value={this.state.client.contactPotalCode} onChange={(e) => {this.setValue(e)}} mask={[/\d/, /\d/, /\d/, /\d/, /\d/]} className={this.state.classNames.contactPotalCode} />
         </FormGroup>
        </Col>
        <Col xs="3">
         <FormGroup className="form-group-clean">
          <Label htmlFor="postal-code">Pais</Label>
          <Input type="text" id="contactCountry" value={this.state.client.contactCountry} onChange={(e) => {this.setValue(e)}} placeholder="Introduce el pais" className={this.state.classNames.contactCountry} />
         </FormGroup>
        </Col>
        <Col xs="3">
         <FormGroup className="form-group-clean">
          <Label>Teléfono</Label>
          <InputGroup>
           <div className="input-group-prepend">
            <span className="input-group-text"><i className="fa fa-phone"></i></span>
           </div>
           <MaskedInput id="contactPhone" value={this.state.client.contactPhone} onChange={(e) => {this.setValue(e)}} mask={[/\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/]} className={this.state.classNames.contactPhone} />
          </InputGroup>
         </FormGroup>
        </Col>
       </FormGroup>

       <FormGroup row>
        <Col xs="6">
         <FormGroup className="form-group-clean">
          <Label htmlFor="postal-code">Correo electrónico</Label>
          <InputGroup>
           <div className="input-group-prepend">
            <span className="input-group-text"><i className="fa fa-envelope"></i></span>
           </div>
           <Input type="text" id="contactEmail" value={this.state.client.contactEmail} onChange={(e) => {this.setValue(e)}} placeholder="Introduce el email" className={this.state.classNames.contactEmail} />
          </InputGroup>
         </FormGroup>
        </Col>
        <Col xs="3">
         <FormGroup className="form-group-clean">
          <Label>Móvil</Label>
          <InputGroup>
           <div className="input-group-prepend">
            <span className="input-group-text"><i className="fa fa-mobile"></i></span>
           </div>
           <MaskedInput id="contactMobile" value={this.state.client.contactMobile} onChange={(e) => {this.setValue(e)}} mask={[/\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/]} className={this.state.classNames.contactMobile} />
          </InputGroup>
         </FormGroup>
        </Col>
        <Col xs="3">
         <FormGroup className="form-group-clean">
          <Label>Fax</Label>
          <InputGroup>
           <div className="input-group-prepend">
            <span className="input-group-text"><i className="fa fa-fax"></i></span>
           </div>
           <MaskedInput id="contactFax" value={this.state.client.contactFax} onChange={(e) => {this.setValue(e)}} mask={[/\d/, /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/]} className={this.state.classNames.contactFax} />
          </InputGroup>
         </FormGroup>
        </Col>
       </FormGroup>
      </TabPane>

      <TabPane tabId="3">
       <FormGroup row>
        <Col xs="5">
         <FormGroup className="form-group-clean">
          <Label htmlFor="postal-code">Nombre del banco</Label>
          <InputGroup>
           <div className="input-group-prepend">
            <span className="input-group-text"><i className="fa fa-bank"></i></span>
           </div>
           <Input type="text" id="paymentBankName" onChange={(e) => {this.setValue(e)}} placeholder="Introduce el nombre del banco" className={this.state.classNames.paymentBankName} />
          </InputGroup>
         </FormGroup>
        </Col>
        <Col xs="7">
         <FormGroup className="form-group-clean">
          <Label>Número de cuenta (IBAN)</Label>
          <InputGroup>
           <div className="input-group-prepend">
            <span className="input-group-text"><i className="fa fa-asterisk"></i></span>
           </div>
           <MaskedInput id="paymentBankAccount" onChange={(e) => {this.setValue(e)}} mask={[/[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]} className={this.state.classNames.paymentBankAccount} />
          </InputGroup>
          <FormText color="muted">ex. ES00 0000 0000 0000 0000 0000</FormText>
         </FormGroup>
        </Col>
       </FormGroup>

       <FormGroup row>
        <Col xs="4">
         <FormGroup>
          <Label>Targeta de credito</Label>
          <InputGroup className="form-group-clean">
           <div className="input-group-prepend">
            <span className="input-group-text"><i className="fa fa-credit-card"></i></span>
           </div>
           <MaskedInput id="paymentCardNumber" onChange={(e) => {this.setValue(e)}} mask={[/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/]} className={this.state.classNames.paymentCardNumber} />
          </InputGroup>
          <FormText color="muted">ex. 9999 9999 9999 9999</FormText>
         </FormGroup>
        </Col>
        <Col xs="4">
         <FormGroup>
          <Label>Fecha de caducidad</Label>
          <InputGroup className="form-group-clean">
           <div className="input-group-prepend">
            <span className="input-group-text"><i className="fa fa-calendar-o"></i></span>
           </div>
           <MaskedInput id="paymentCardExpire" onChange={(e) => {this.setValue(e)}} mask={[/\d/, /\d/, '/', /\d/, /\d/, ]} className={this.state.classNames.paymentCardExpire} />
          </InputGroup>
          <FormText color="muted">ex. 99/99</FormText>
         </FormGroup>
        </Col>
        <Col xs="4">
         <FormGroup>
          <Label>CVV</Label>
          <InputGroup className="form-group-clean">
           <div className="input-group-prepend">
            <span className="input-group-text"><i className="fa fa-lock"></i></span>
           </div>
           <MaskedInput id="paymentCardCode" onChange={(e) => {this.setValue(e)}} mask={[/\d/, /\d/, /\d/, ]} className={this.state.classNames.paymentCardCode} />
          </InputGroup>
          <FormText color="muted">ex. 999</FormText>
         </FormGroup>
        </Col>
       </FormGroup>
      </TabPane>
     </TabContent>
    </ModalBody>

    <ModalFooter>
     <div className="text-danger"><strong>{this.state.errMessage}</strong></div>
     <Button color="danger" onClick={this.handleClose}>Cancelar</Button>
     <LaddaButton
      type="submit"
      onClick={this.handleSave}
      className="btn btn-success btn-ladda" 
      data-style={EXPAND_LEFT} 
      loading={this.state.laddaloading}>
      {this.state.editorMode?'Guardar cambios':'Crear cliente'}
     </LaddaButton>
    </ModalFooter>
   </Modal>
  )
 }

}

export default ClientEditor;



// WEBPACK FOOTER //
// ./src/components/Client/Editor.js